
import { i18nText } from '@/locales';

import {Component, Prop, Vue} from "vue-property-decorator";
import FinanceOperationsAddForm from "@/form/finance/finance_operations/FinanceOperationsAddForm";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import moment from 'moment-timezone';
import {ClientsStore} from "@/store/modules/Clients";
import {CounterpartiesStore} from "@/store/modules/Counterparties";
import {WorkersStore} from "@/store/modules/Workers";
import {getStudioId} from "@/UI/lib/state";

@Component({
  components: {FormGroup},
  methods: {moment}
})
export default class FinanceOperationsAddComponent extends Vue {
  @Prop() readonly form!: FinanceOperationsAddForm;
  targetType = 1;
  targetName = i18nText("Контрагент");
  date = '';
  time = '';
  radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px'
  };
  get currentTimeMoscow() {
    moment.tz.setDefault('Europe/Moscow');
    return moment();
  }

  filterOption(input: string/*, option: VNode*/): void {
    console.log(input);
  }

  async searchTarget(val: any): Promise<void> {
    this.form.target = ''
    if (this.targetType === 1) {
      await CounterpartiesStore.fetchAll({filter: {name: val, salon_id: getStudioId(this)}})
      this.form.targets = CounterpartiesStore.counterparties!.data
    }
    if (this.targetType === 2) {
      await ClientsStore.fetchAll({filter: {name: val, salon_id: getStudioId(this)}})
      this.form.targets = ClientsStore.clients!.data
    }
    if (this.targetType === 3) {
      await WorkersStore.fetchAll({filter: {name: val, salon_id: getStudioId(this)}})
      this.form.targets = WorkersStore.workers!.data?.filter((worker: any) => worker.status.id !== 2)
    }
  }

  handleDateChange(value: any): void {
    if (value != null && value != '') {
      this.form.clearErrors('date');
      this.date = value;
      this.form.date = value.format('DD.MM.YYYY');
    } else {
      this.form.setErrors('date', i18nText("Введите корректную дату"));
    }
  }

  handleTimeChange(value: any): void {
    console.log('++++++++++++++++++++1676275165++++++++++++++++++++++++');
    console.log('value : ' + (typeof value));
    console.log(value);
    console.log('--------------------1676275165------------------------');

    if (value != null && value != '') {
      this.form.clearErrors('time');
      this.time = value;
      this.form.time = value.format('HH:mm');
    } else if (value === null) {
      // value='00:00';
      value = moment('00:00', 'HH:mm');
      this.time = value;
      this.form.time = value.format('HH:mm');

    } else {
      this.form.setErrors('time', i18nText("Введите корректное время"));
    }
  }



  submit(): void {
    this.form.salon_id = getStudioId(this);
    this.form.targetType = this.targetType;
    this.$emit('submit');
  }

  onChange(event?: any): void {
    switch (this.targetType) {
      case 1:
        this.targetName = i18nText("Контрагент");
        break;
      case 2:
        this.targetName = i18nText("Клиент");
        break;
      case 3:
        this.targetName = i18nText("Сотрудник");
        break;
      default:
        break;
    }
    this.searchTarget('');
  }
}
